var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChainOptimism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#FF0420"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M5.288 21.067q1.305.933 3.35.933 2.472 0 3.949-1.117 1.477-1.133 2.079-3.416.36-1.4.619-2.884.084-.53.085-.884 0-1.165-.601-1.999a3.6 3.6 0 0 0-1.65-1.266Q12.07 10 10.749 10q-4.858 0-6.026 4.583a53 53 0 0 0-.636 2.884q-.077.447-.087.898 0 1.752 1.288 2.702m6.2-3.7c-.33 1.276-1.235 2.107-2.611 2.107-1.36 0-1.824-.92-1.579-2.107a36 36 0 0 1 .619-2.733c.353-1.379 1.187-2.107 2.608-2.107 1.356 0 1.797.906 1.564 2.107a40 40 0 0 1-.601 2.733m4.625 4.01q.101.12.285.12h2.272a.5.5 0 0 0 .317-.12.48.48 0 0 0 .184-.309l.718-3.36h2.31c1.459 0 2.6-.707 3.435-1.336q1.271-.943 1.688-2.914.1-.465.1-.894 0-1.489-1.135-2.28Q25.16 10 23.68 10h-4.444a.5.5 0 0 0-.317.12.5.5 0 0 0-.184.31l-2.307 11.14a.4.4 0 0 0 .05.31m7.217-7.955c-.21.919-1.01 1.758-1.95 1.758h-1.92l.662-3.158h2.004c.683 0 1.253.135 1.253.886q0 .22-.049.514",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainOptimism);
export default __webpack_public_path__ + "static/media/chain-optimism.d2125c4c70a6d3351525d388191e733a.svg";
export { ForwardRef as ReactComponent };